export enum routerPathMain {
    ADD = '/them-moi',
    ADD_FROM_FILE = '/them-moi-tu-file',
    ADD_FROM_TEMPLATE = '/them-moi-tu-mau',
    EDIT = '/cap-nhat',
    UPGRADE = '/nang-cap',
    VIEW = '/xem-chi-tiet',
    GROUP = '/ben-tham-gia',
    POSITION = '/dat-vi-tri',
    NUMBERED = '/danh-so',
    MY_DOCUMENT = '/my-document',
    CONTRACT_SIGN = '/hop-dong-can-ky',
    CONTRACT_LABOR_SIGN = '/hop-dong-lao-dong-can-ky',
    CONTRACT_DOCUMENT_SIGN = '/ho-so-hop-dong-can-ky',
    DOC_SIGN = '/van-ban-can-ky',
    DUPLICATE_CONTRACT = '/ban-sao-hop-dong',
    DUPLICATE_CONTRACT_LABOR = '/ban-sao-hop-dong-lao-dong',
    DUPLICATE_CONTRACT_DOCUMENT = '/ban-sao-ho-so-hop-dong',
    DUPLICATE_SUBMISSION = '/ban-sao-van-ban',
    DUPLICATE_DOC = '/ban-sao-tai-lieu',
    DECLARE = '/khai-bao-thong-tin',
    END = '/ket-thuc',
    SEARCH = '/search',
    PDF = '/pdf',
    BATCH_SIGNER_ADD = "/them-moi-trinh-ky-theo-lo",
    BATCH_SIGNER_VIEW = "/xem-chi-tiet-trinh-ky-theo-lo",
    BATCH_SIGNER_EDIT = "/cap-nhat-trinh-ky-theo-lo",
    QUICK_SIGNER_ADD = "/them-moi-trinh-ky-nhanh",
    QUICK_SIGNER_EDIT = "/cap-nhat-trinh-ky-nhanh",
    LOT = "/ky-lo",
    STOP_EFFECT = "/dung-hieu-luc",
    ADD_APPENDIX = "/them-moi-phu-luc",
    ADD_EXTEND = "/them-moi-gia-han",
    ADD_TERMINATE = "/them-moi-cham-dut",
    EDIT_FROM_TEMPLATE = '/cap-nhat-tu-mau',
    EDIT_FROM_FILE = '/cap-nhat-tu-file',
    EDIT_APPENDIX = '/cap-nhat-phu-luc',
    EDIT_EXTEND = '/cap-nhat-gia-han',
    EDIT_TERMINATE = '/cap-nhat-cham-dut',
    COMPLETE = '/hoan-tat',
    TAO_HD = "/tao-hop-dong",
    HOAN_TAT = "/hoan-tat",
}
